import { Navigate, useOutletContext, useLocation } from "react-router";
import { MODULE_DEFINITIONS, isModuleSlug, type ModuleSlug } from "@a2/core";
import type { SessionUser } from "../lib/session-loader";
import { useT } from "../lib/use-t";

export function LockedModuleGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const session = useOutletContext<SessionUser>();
  const t = useT();
  const firstSegment = pathname.split("/")[1] ?? "";

  if (!isModuleSlug(firstSegment)) {
    return <>{children}</>;
  }
  const status = session.moduleStatusMap[firstSegment as ModuleSlug];
  if (status === "active") return <>{children}</>;

  try {
    sessionStorage.setItem("a2:flash", t("lockedModule.comingSoonFlashFmt", { module: firstSegment }));
  } catch {
    // ignore
  }
  const defaultRoute = session.defaultModule
    ? MODULE_DEFINITIONS[session.defaultModule].route
    : "/welkom";
  return <Navigate to={defaultRoute} replace />;
}
